// Venmo is always available on web
export function isVenmoAvailable(): boolean {
  return true;
}
